// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";

/**
 * Compact loading indicator for use inside existing containers (tables,
 * cards, modals, overlays). Matches the visual style of PageLoader so the
 * whole app uses one spinner look.
 *
 * For a full-page loading state (replaces the page content), prefer
 * <PageLoader message="..." />.
 *
 * Usage:
 *   {loading && <LoadingOverlay message="Lade Produkte..." />}
 */
const LoadingOverlay = ({ message = "Lädt..." }) => (
  <div className="flex items-center justify-center py-12">
    <div className="text-center">
      <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-primary-color mx-auto mb-4"></div>
      <p className="text-lg text-gray-600 dark:text-slate-400 font-medium">
        {message}
      </p>
    </div>
  </div>
);

export default LoadingOverlay;
